import { CreateAssetPage } from "../create_asset"
import { AssetCategoryApi, AssetAreaApi, FacilityApi, AssetApi } from "../../api/api"
import { CreateAssetTempStore } from '../../store/temp_store'
import { UiUtils, JqElm } from "../ui"
import { AssetMgtPageLoaderBase } from "./index"
/**
 * 頁面 /community/assetCreate.aspx 執行此 Page loader
 */
export class AssetMgtCreateAssetLoader extends AssetMgtPageLoaderBase {

    private page: CreateAssetPage
    private initCategories: Promise<void>
    private initFacilities: Promise<void>
    private initAreas: Promise<void>
    constructor() {
        super()
        this.page = new CreateAssetPage(new AssetApi(), new AssetCategoryApi(), new FacilityApi(), new AssetAreaApi(), new CreateAssetTempStore())
    }

    async load(): Promise<void> {
        this.initCategories = this.page.initCategories()
        this.initFacilities = this.page.initFacilities()
        this.initAreas = this.page.initAreas()
    }

    async loadOnDocumentReady(): Promise<void> {
        //Init no depedency first
        this.page.listenFacilityIdsChange()
        this.page.listenNoteChange()
        this.page.listenShortcutLinks()
        this.page.listenTypeClick()
        this.page.listenAddBtnClick() //Dependencies - create item data
        this.page.listenFacilityEnable()
        this.page.listenDeleteClick()
        this.page.listenExcelTemplateDownloadClick()
        //Init Modal
        this.page.initFacilityModal()
        this.page.initNoteModal()
        this.page.initCloneModal()
        this.page.initExcelFileUpload()

        //Init asset help data
        await Promise.all([this.initAreas, this.initCategories, this.initFacilities])
        this.page.initFacilityElms()
        const newEmptyCreateAssetElm = this.page.appendCreateAssetElm()
        this.page.fillCategoryElmData(
            newEmptyCreateAssetElm.find('select[name=categoryRootId]'),
            newEmptyCreateAssetElm.find('select[name=categoryId]')
        )
        this.page.fillAreaElmData(newEmptyCreateAssetElm.find('select[name=area]'))
        if (this.page.hasTempData()) {
            if (await UiUtils.confirm("上次作業未完成，是否還原？")) {
                this.page.restoreTempData()
            } else {
                this.page.cleanTempData()
            }
        }

        //Last
        this.page.listenFormChange()
        this.page.listenCreateClick()

    }

}
